"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AppInfoSidebar_1 = __importDefault(require("./AppInfoSidebar"));
var RenderingOptionsSidebar_1 = __importDefault(require("./RenderingOptionsSidebar"));
var SettingsSidebar_1 = __importDefault(require("./SettingsSidebar"));
var AppTranslationSidebar_1 = __importDefault(require("./AppTranslationSidebar"));
var AppEditorSidebar = function (_a) {
    var activeTab = _a.activeTab, appData = _a.appData, onUpdateSetting = _a.onUpdateSetting, onRemoveSetting = _a.onRemoveSetting, onAppDataUpdate = _a.onAppDataUpdate;
    switch (activeTab) {
        case "App Info":
            return react_1.default.createElement(AppInfoSidebar_1.default, { appData: appData, onAppDataUpdate: onAppDataUpdate });
        case "Rendering Options":
            return (react_1.default.createElement(RenderingOptionsSidebar_1.default, { appData: appData, onAppDataUpdate: onAppDataUpdate }));
        case "Settings":
            return (react_1.default.createElement(SettingsSidebar_1.default, { appData: appData, onUpdateSetting: onUpdateSetting, onRemoveSetting: onRemoveSetting }));
        case "Translations":
            return (react_1.default.createElement(AppTranslationSidebar_1.default, { appData: appData, onAppDataUpdate: onAppDataUpdate }));
        default:
            return null;
    }
};
exports.default = AppEditorSidebar;
